import { axiosWithAuth, getFormattedDate } from "helpers";

export const dataCleanseService = {
	getDataCleanseLists,
	refreshLists,
	completeReview,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

const PAGE_SIZE = 50;

function getDataCleanseLists({
	paidMonth,
	paidYear,
	isMerchantMissing = false,
	isMissingScheduleASplitProfile = false,
	page,
	filters,
	sortBy,
}) {
	const processingMonth = getFormattedDate({
		date: filters?.processingMonth,
		format: "MMM yyyy",
	});

	const businessUnit =
		filters?.businessUnit?.parent?.name || filters?.businessUnit?.name;

	const businessUnitHierarchy =
		filters?.businessUnit?.parent && filters?.businessUnit?.name;

	return axiosWithAuth({
		method: "GET",
		params: {
			paid_year: paidYear,
			paid_month: paidMonth,
			is_merchant_missing: isMerchantMissing,
			is_schedule_a_or_split_profile_missing:
				isMissingScheduleASplitProfile,
			page_size: PAGE_SIZE,
			page_index: page,
			mid: filters?.mid,
			merchant_name: filters?.merchantName,
			agent_name: filters?.agentName,
			partner_type: filters?.partnerType?.name,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			platform_marker: filters?.platformMarker,
			is_schedule_a_missing: filters?.isScheduleAMissing,
			is_split_profile_missing: filters?.isSplitProfileMissing,
			source_of_data: filters?.sourceOfData?.name,
			processing_month: processingMonth || null,
			sort_type: sortBy?.id ? sortBy?.id : undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}/records`,
	});
}

function refreshLists({ paidMonth, paidYear, acceptMerchantChanges = false }) {
	const options = {
		method: "POST",
		params: {
			accept_merchant_changes: acceptMerchantChanges,
		},
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}/records/refresh`,
	};

	return axiosWithAuth(options);
}

function completeReview({ paidYear, paidMonth }) {
	const options = {
		method: "POST",
		url: `${RESIDUALS_API_URL}/api/normalization_data/${paidYear}/${paidMonth}/review/complete`,
	};

	return axiosWithAuth(options);
}
